import { cn } from "@omni/utils/styles";

import { Sidebar } from "@/components/General/Sidebar/sidebar";

type Props = {
    accountLinks: string;
    profilelink: string;
    innerHTML?: string;
};

export const SidebarDefault = ({
    accountLinks,
    profilelink,
    innerHTML
}: Props) => {
    return (
        <Sidebar
            accountLinks={accountLinks}
            profilelink={profilelink}
            innerHTML={innerHTML}
        >
            <Sidebar.Assortiment.Trigger />
            <Sidebar.Assortiment.RootCategory>
                <Sidebar.Assortiment.CategoryLinks>
                    <Sidebar.Assortiment.CategoryLinks.Link
                        className={cn("tw:pl-12")}
                    />
                </Sidebar.Assortiment.CategoryLinks>
            </Sidebar.Assortiment.RootCategory>
            <Sidebar.Assortiment.SubCategories>
                <Sidebar.Assortiment.CategorySlide>
                    <Sidebar.Assortiment.CategorySlide.Back />
                    <Sidebar.Assortiment.CategorySlide.Header />
                    <div className={cn("tw:flex tw:flex-col tw:overflow-auto")}>
                        <Sidebar.Assortiment.CategoryLinks>
                            <Sidebar.Assortiment.CategoryLinks.Link />
                        </Sidebar.Assortiment.CategoryLinks>
                    </div>
                </Sidebar.Assortiment.CategorySlide>
            </Sidebar.Assortiment.SubCategories>
            <Sidebar.InnerHtml />
            <Sidebar.AccountLinks />
            <Sidebar.LanguageSelector />
        </Sidebar>
    );
};
